'use client';

import { useRef } from 'react';
import { DomainsConfig } from 'next-intl/routing';
import { useServerInsertedHTML } from 'next/navigation';

export default function RuntimeDomains({
  domains,
  nonce,
}: {
  domains: DomainsConfig<ReadonlyArray<string>>;
  nonce: string;
}) {
  const isServerInserted = useRef(false);
  useServerInsertedHTML(() => {
    if (isServerInserted.current) return;
    isServerInserted.current = true;
    return (
      <script
        id="runtimeDomains"
        nonce={nonce}
      >{`window.__runtimeDomains = ${JSON.stringify(domains)}`}</script>
    );
  });

  return null;
}
